import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Provider from '../Provider';
import Style from './ProviderGroup.module.scss';

const ProviderGroup = (props = {}) => {
  const {
    groupName,
    isLive,
    onProviderClick,
    previewPassExpired,
    previewPassSignIn,
    profileId,
    providers,
    selectedChannel,
  } = props;
  if (!providers || !providers.length || !groupName) return null;
  const providerProps = {
    onProviderClick,
    selectedChannel,
    isLive,
    previewPassExpired,
    previewPassSignIn,
    profileId,
  };
  return (
    <div className={Style.providerGroup} providers-group={groupName}>
      <div className={Style.providerGroupKey}>{groupName}</div>
      {providers.map(provider => (
        <Provider key={_.get(provider, 'name')} {...provider} {...providerProps} />
      ))}
    </div>
  );
};

ProviderGroup.defaultProps = {
  groupName: null,
  onProviderClick: () => {},
  previewPassExpired: null,
  previewPassSignIn: false,
  selectedChannel: null,
  profileId: null,
  providers: null,
  isLive: null,
};
ProviderGroup.propTypes = {
  groupName: PropTypes.string,
  providers: PropTypes.arrayOf(PropTypes.shape({})),
  isLive: PropTypes.bool,
  onProviderClick: PropTypes.func,
  previewPassExpired: PropTypes.bool,
  previewPassSignIn: PropTypes.bool,
  profileId: PropTypes.string,
  selectedChannel: PropTypes.number,
};

export default ProviderGroup;
